import Vue from 'vue';

import App from '@/App.vue';
import store from '@/store/store';
import router from '@/router';

// Vue Page Transition
import VuePageTransition from 'vue-page-transition';
Vue.use(VuePageTransition);

// Buefy
import Buefy from 'buefy';
Vue.use(Buefy);

import VueFusionCharts from 'vue-fusioncharts';
import FusionCharts from 'fusioncharts';
import Charts from 'fusioncharts/fusioncharts.charts';
import PowerCharts from 'fusioncharts/fusioncharts.powercharts';
import ExcelExport from 'fusioncharts/fusioncharts.excelexport';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';

FusionCharts.options.creditLabel = false;
Vue.use(VueFusionCharts, FusionCharts, PowerCharts, Charts, ExcelExport, FusionTheme);

// Print
import VueHtmlToPaper from '@/plugins/vue-html-to-paper';

const printOptions = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=no', 'scrollbars=yes'],
  styles: ['https://cdn.jsdelivr.net/npm/bulma@0.8.0/css/bulma.min.css']
};

Vue.use(VueHtmlToPaper, printOptions);

// trend
import TrendChart from 'vue-trend-chart';
Vue.use(TrendChart);

// Filters & Mixins
import '@/plugins/filters';
import '@/plugins/mixins';

// Global layout components
import Loader from '@/components/shared/Loader';
Vue.component('Loader', Loader);

Vue.config.productionTip = false;

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
